module.exports = __webpack_public_path__ + "static/img/5areaB_4.f343564.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_4.png
// module id = 1205
// module chunks = 1